import { useArrayTagsInput } from 'hooks/useArrayItems/useArrayTagsInput';
import { useRef } from 'react';

export const useSandboxModalFields = () => {
  const teamNameRef = useRef(document.createElement('input'));
  const creatorRef = useRef(document.createElement('input'));

  const {
    addTag,
    removeTag,
    inputRef,
    tagsList,
    tagError,
    setTagsList,
    applyTagsChange,
    clearErrorAndTags,
    handleCheckboxChange,
    standardTags,
    clearStandardTags,
    setStandardTags,
  } = useArrayTagsInput();

  return {
    addTag,
    removeTag,
    inputRef,
    tagsList,
    tagError,
    setTagsList,
    applyTagsChange,
    clearErrorAndTags,
    handleTagCheckboxChange: handleCheckboxChange,
    standardTags,
    clearStandardTags,
    teamNameRef,
    creatorRef,
    setStandardTags,
  };
};
